import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';
import { useSecureSSNContext } from 'lib/context/SecureSSNContext/SecureSSNContext';

import state from 'components/state';
import Icon from 'components/shared/Icon/Icon';

const SecureSSNChange = ({ secureContext, prevValue, currValue, showOnlyNewValue }) => {
  const permissions = useRecoilValue(state.permissions);
  const { revealedSSNs, revealSSN, hideSSN } = useSecureSSNContext();

  const [isRevealing, setIsRevealing] = useState(false);

  const canReveal = Boolean(secureContext) && pm(permissions, 'secure.read');
  const revealed = canReveal ? revealedSSNs[secureContext.history_id] : null;

  const handleToggleReveal = async () => {
    if (revealed) {
      hideSSN(secureContext.history_id);
      return;
    }

    setIsRevealing(true);
    await revealSSN(secureContext);
    setIsRevealing(false);
  };

  const previous = revealed ? revealed.previous || 'blank' : prevValue;
  const current = revealed ? revealed.current || 'blank' : currValue;

  return (
    <>
      {!showOnlyNewValue && (
        <>
          <span className="font-500 text-neutral-500">from</span>
          <span className="font-500 text-neutral-500" data-dd-privacy="mask">
            {previous}
          </span>
          <span className="font-500 text-neutral-500">to</span>
        </>
      )}

      <span className="font-semibold text-neutral-800" data-dd-privacy="mask">
        {current}
      </span>

      {canReveal && (
        <Icon
          size={16}
          color="primary"
          disabled={isRevealing}
          onClick={handleToggleReveal}
          icon={revealed ? 'eye-slash-mono' : 'eye-mono'}
          data-qa="reveal-activity-ssn"
          className="cursor-pointer"
        />
      )}
    </>
  );
};

export default SecureSSNChange;
